import React from 'react'
import { useNavigate } from 'react-router-dom'

import FocusableCard from './FocusableCard'

import type { CardProps } from './types'
import type { Show } from '../../reducers/types/reducerTypes'

export function ShowCard({
  data,
  index,
  onFocus,
  layout,
  ttsCounterText,
  onArrowPress,
  focusKey,
}: CardProps<Show>) {
  const navigate = useNavigate()

  const bgImage = `${
    data.images['show-poster2x3'] ? data.images['show-poster2x3'] : ''
  }`

  const hasImage = !!bgImage
  const handleOnEnterPress = () => {
    navigate(`/show-details/${data.slug}`)
  }

  return (
    <FocusableCard<Show>
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} .... ${data.title}`}
      onEnterPress={handleOnEnterPress}
      onArrowPress={onArrowPress}
      focusKey={focusKey}
    >
      <div className="card-show__container">
        {hasImage && (
          <img
            className="card-show__background-image"
            src={`${bgImage}?resize=260x390&format=webp`}
            alt={`${data.title} show poster`}
          />
        )}
        {!hasImage && <span className="card-show__title">{data.title}</span>}
      </div>
    </FocusableCard>
  )
}
